import React, { useEffect } from 'react'
import 'stylesheets/EventsStyles/EventsStyles.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import EventElement from './EventElement';
import { useEvents } from 'hooks/events';
import SpinnerLoading from '../Spiners';

const Events = () => {
    const { events, isLoading: eventsLoading } = useEvents();
    useEffect(() => {
        const body = document.querySelector('body');
        body.style.overflowY = 'auto'
    }, [])


    return (
        <>
            <h1 className='events-title'>Come and join to us!</h1>
            <h3 className='events-subtitle'>See upcoming events to get amazing prices</h3>
            <div className="sponsored-events-container">
                <h2>Social Events</h2>
                {
                    eventsLoading
                        ?
                        <SpinnerLoading />
                        :
                        <Swiper
                            className='swiper-container'
                            spaceBetween={50}
                            slidesPerView='auto'
                        >
                            {
                                events.map(event => {
                                    if (event.type === 'social') {
                                        return <SwiperSlide key={event.id}><EventElement sponsored={false} event={event} /></SwiperSlide>
                                    }
                                })
                            }
                        </Swiper>
                }
            </div>
        </>
    )
}

export default Events